export const getLiveList = {
  url: '/admin/live/list.json',
  method: 'get'
};

export const getLiveDetail = {
  url: '/admin/live/detail.json',
  method: 'get'
};

export const saveLive = {
  url: '/admin/live/save.json',
  method: 'post'
};

export const updateLiveStatus = {
  url: '/admin/live/updateStatus.json',
  method: 'post'
};

export const getLiveSubscribeList = {
  url: '/admin/live/subscribe/list.json',
  method: 'get'
};
